export class URLPreAutenticada {
    url: string
}
